import { NavLink } from 'react-router-dom';
import {
  FiHome,
  FiUsers,
  FiPackage,
  FiTool,
  FiClipboard,
  FiSettings,
  FiUserPlus,
  FiDollarSign,
  FiNavigation,
  FiFileText,
  FiBarChart2,
} from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = () => {
  const menuItems = [
    { path: '/dashboard', icon: <FiHome />, label: 'Dashboard' },
    { path: '/technicians', icon: <FiUsers />, label: 'Technicians' },
    { path: '/technicians/map', icon: <FiNavigation />, label: 'Live Tracking' },
    { path: '/customers', icon: <FiUsers />, label: 'Customers' },
    { path: '/helpers', icon: <FiUserPlus />, label: 'Helpers' },
    { path: '/inventory', icon: <FiPackage />, label: 'Inventory' },
    { path: '/tools', icon: <FiTool />, label: 'Tools' },
    { path: '/site-visits', icon: <FiClipboard />, label: 'Site Visits' },
    { path: '/invoices', icon: <FiFileText />, label: 'Invoices' },
    { path: '/expenses', icon: <FiDollarSign />, label: 'Expenses' },
    { path: '/reports/revenue', icon: <FiBarChart2 />, label: 'Revenue Reports' },
    { path: '/settings', icon: <FiSettings />, label: 'Settings' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="logo-icon">
            <FiTool />
          </div>
          <h2 className="logo-text">HVAC Manager</h2>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item, index) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `nav-item ${isActive ? 'nav-item-active' : ''}`
            }
            style={{ animationDelay: `${index * 50}ms` }}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-footer-content">
          <p className="footer-text">HVAC Shop Management</p>
          <p className="footer-version">v1.0.0</p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
